import { render, staticRenderFns } from "./Old-Header.vue?vue&type=template&id=fdf14abe"
import script from "./Old-Header.vue?vue&type=script&lang=js"
export * from "./Old-Header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports